import { Card, CardHeader, List } from "@mui/material";
import { HREF_NOTIZEN_WIEDERVORLAGE } from "global/util/routes";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CockpitListItemButton } from "../ListItemButton/ListItemButton";
import { CockpitListItemText } from "../ListItemText/ListItemText";
import { ListItemTypography } from "../ListItemTypography/ListItemTypography";

interface props {
  countOfNotes: number;
  notesVisible: boolean;
}

const Notizen: React.FC<props> = (props: props) => {
  // Variablen und Hooks
  const [countOfNotes, setCountOfNotes] = useState(Number);
  const [notesVisible, setNotesVisible] = useState(Boolean);

  let navigate = useNavigate();

  useEffect(() => {
    setCountOfNotes(props.countOfNotes);
    setNotesVisible(
      props.notesVisible !== undefined ? props.notesVisible : false
    );
  }, [props.countOfNotes, props.notesVisible]);

  // React-Tree
  return (
    <Card hidden={!notesVisible}>
      <CardHeader title="Notizen" />
      <List disablePadding>
        <CockpitListItemButton
          divider
          aria-label="Notizen"
          onClick={() => navigate(HREF_NOTIZEN_WIEDERVORLAGE)}
        >
          <CockpitListItemText primary="Notizen Wiedervorlage: " />
          <ListItemTypography text={`${countOfNotes}`} id="countOfNotes" />
        </CockpitListItemButton>
      </List>
    </Card>
  );
};

export default Notizen;
